/**
 * 공모전(응모 이력) 탭만 노출할 어드민 이메일 목록.
 *
 * 여기 등록된 계정은 사이드바에 공모전 탭만 보이고, 로그인 후 공모전 페이지로
 * 이동한다. 이메일을 추가하려면 아래 배열에 한 줄 넣고 배포하면 된다.
 *
 * ⚠️ 이것은 UI 노출 제어일 뿐 접근 차단이 아니다.
 *    다른 탭의 URL 을 직접 입력하거나 API 를 직접 호출하는 것은 막지 않는다
 *    (서버 AdminGuard 는 여전히 isAdmin 여부만 본다). 신뢰하는 내부 인원 전제.
 *    외부 심사위원 등에게 열려면 서버 스코프 가드가 별도로 필요하다.
 */
const CONTEST_ONLY_ADMIN_EMAILS: string[] = [
  "diokim@doseodam.com",
  "soo@novelastudio.com",
];

/** 공모전 전용 계정이 로그인 후 처음 진입할 경로. */
export const CONTEST_ONLY_HOME = "/contest-submissions";

/** 이 이메일이 공모전 탭만 볼 수 있는 계정인지 여부. 대소문자 무시. */
export function isContestOnlyAdmin(email: string | null | undefined): boolean {
  if (!email) return false;
  const target = email.toLowerCase();
  return CONTEST_ONLY_ADMIN_EMAILS.some((e) => e.toLowerCase() === target);
}
